exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#mobileInfoWindow{position:absolute;top:-56px;bottom:68px;right:0;left:0;overflow:auto;z-index:1500}#mobileInfoWindow .animation-padder{height:56px}#mobileInfoWindow .content{padding:16px;background-color:#fff;min-height:calc(100vh - 56px - 68px)}#mobileInfoWindow .content .infographic{background-color:#f9f9f9;border:1px solid #ddd}#mobileInfoFooter{position:absolute;z-index:1500;bottom:0;left:0;right:0;padding:16px;background-color:#f9f9f9;border-top:1px solid #ddd;-webkit-box-shadow:rgba(0,0,0,0.12) 0px 1px 6px,rgba(0,0,0,0.12) 0px 1px 4px;box-shadow:rgba(0,0,0,0.12) 0px 1px 6px,rgba(0,0,0,0.12) 0px 1px 4px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/MapMarker/style.scss
// module id = 1316
// module chunks = 0